import { Component, OnInit } from '@angular/core';
import { PartenariatService } from 'src/app/_services/partenariat/partenariat.service';
import { Partenariat } from 'src/app/Model/partenariat';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
@Component({
  selector: 'app-sponsor',
  templateUrl: './sponsor.component.html',
  styleUrls: ['./sponsor.component.css']
})
export class SponsorComponent implements OnInit {

  constructor(private servicePart: PartenariatService, private http: HttpClient,
    private snotifyService: SnotifyService, private router: Router) { }

  partenariat: Partenariat[] = [];
  part = new Partenariat;
  Ancpart = new Partenariat;
  image: any;
  modif = false;
  ajout = true;
  spons = ['font', 'officiel'];
  sponsor = ['all', 'font', 'officiel'];
  filterTable: any;
  ngOnInit(): void {

    this.affichePartenariat();
  }
  affichePartenariat() {
    this.servicePart.Afficherpartenariat().subscribe(res => {
      this.partenariat = res;

    });
  }
  delete(e) {
    this.servicePart.deletePartenariat(e._id).subscribe(res => {
      this.affichePartenariat();
    });

  }
  selectImage(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.image = file;
    }
  }
  onChange(event) {
    console.log(event);
    //   this.profit.etablissement= event;
  }

  onSubmit(part) {
    const formData = new FormData();
    formData.append('files', this.image);
   // console.log(part);
    this.http.post<any>('http://notregrandbleu.herokuapp.com/partenariat/uploads', formData).
      subscribe(res => {

        res.fich.forEach(element => {
        
          this.part.image =  element.originalname;
        });
        this.servicePart.addPartenariat(this.part).subscribe(ress => {
          this.affichePartenariat();

          this.snotifyService.success('Demande ajoutée avec succès merci beaucoup',
            {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            }),
            err =>
              this.snotifyService.error('Error', {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              })

         // console.log(ress);
        });
      });

  }

  selectOption(id) {
    if (id == "all") {
      this.servicePart.Afficherpartenariat().subscribe(data => {
        this.partenariat = data;
      });
    }
    else {
      this.servicePart.Afficherpartenariat().subscribe(data => {
        this.partenariat = data;
        this.filterTable = [];
        this.partenariat.forEach(element => {
          if (element.type == id) {
           // console.log(element);
            this.filterTable.push(element);
          }
        });
        this.partenariat = this.filterTable;
       // console.log(this.partenariat);
      });
    }

  }
  modify() {
    if ((this.image == undefined)) {
    //  console.log(this.part.type);
     // console.log(this.Ancpart.type);
      if (this.Ancpart.website == this.part.website && this.part.type == this.Ancpart.type) {
        alert("aucun changement");
      }
      else {
      //  console.log(this.part);
        this.servicePart.modify(this.part).subscribe(res => {
          this.affichePartenariat();
          alert("website ou type part modifier");
        });
      }
    } else {
      const formData = new FormData();
      formData.append('files', this.image);
      this.http.post<any>('http://notregrandbleu.herokuapp.com/partenariat/uploads', formData).
        subscribe(res => {
          res.fich.forEach(element => {
            this.part.image =  element.originalname;
          });
          this.servicePart.modify(this.part).subscribe(ress => {
          //  console.log(ress);
            this.affichePartenariat();
            alert("document modifier")
          });
        });
    }
  }
  modifier(p) {

    this.modif = true;
    this.ajout = false;
    this.part._id = p._id ;
    this.part.website = p.website;
    this.part.type = p.type;
    this.part.image = p.image;

    this.Ancpart._id = p._id ;
    this.Ancpart.website = p.website;
    this.Ancpart.type = p.type;
    this.Ancpart.image = p.image;
  }


}
